import gql from 'graphql-tag';
import moment from 'moment';

import queries from './constants';

export const getActivities = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${queries.gql.GET_ACTIVITIES}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.activities)
    .then((activities) => activities.items);

export const getRawSlots = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${queries.gql.GET_ROW_SLOTS}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.activityRowSlots)
    .then((activityRowSlots) => activityRowSlots.items);

/* */
export const activityCancel = (client, variables) => client
    .mutate({
      mutation: gql`
        ${queries.gql.ACTIVITY_CANCEL}
      `,
      variables,
    })
    .then(({ data }) => data.activityCancel);

/* */
export const activityEdit = (client, variables) => client
    .mutate({
      mutation: gql`
        ${queries.gql.ACTIVITY_EDIT}
      `,
      variables,
    })
    .then(({ data }) => data.activityEdit);

/* */
export const activityBook = (client, details) => {
  const {
    players = [],
    bookingInfo,
    comment,
    paymentMethod,
    accountId,
    // Portefeuille Payline pour un paiement par compte client (type 2). Sans lui,
    // master posait `payments[0].accountId = undefined` et le PGB refusait en R313.
    walletId = null,
  } = details || {
    players: null,
    bookingInfo: null,
  };
  const {
    firstname,
    lastname,
    email,
    phone,
    reference,
    covidCertificate,
  } = (players && players[0]) || {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    reference: '',
  };
  const {
 activity, startsAt, endsAt, duration, pricing, typeId,
} = bookingInfo || {
    activity: null,
    startsAt: null,
    duration: null,
    pricing: [],
    typeId: null,
  };
  const { hourPrice: hourPrices } = activity || {
    hourPrices: [],
  };
  const hourPrice = hourPrices.find((h) => h.time === duration && h.typeId === typeId) || {};
  const { pgbCodeProd } = hourPrice;
  const variables = {
    nb: players.length,
    date: moment(startsAt).format('YYYY-MM-DD'),
    time: moment(startsAt).format('HHmm'),
    time9in: moment(endsAt).format('HHmm'),
    duration,
    lockCode: null,
    accountId,
    golf: {
      id: details.golf.id,
      name: details.golf.name,
    },
    owner: {
      tid: reference,
      name: `${firstname} ${lastname}`,
      email,
      phone,
      covidCertificate,
    },
    total: {
      currency: 'EUR',
      price: pricing.reduce((acc, p) => acc + (p.price ? p.price : 0), 0),
      discount: pricing.reduce((acc, p) => acc + (p.discount ? p.discount : 0), 0),
      initPrice: pricing.reduce((acc, p) => acc + (p.initPrice ? p.initPrice : 0), 0),
    },
    activity: {
      id: activity.id,
      typeId: bookingInfo.typeId,
      resourceId: bookingInfo.resourceId,
      pgbCodeProd,
      name: activity.name,
    },
    comment,
    players: players.map((player, index) => ({
      tid: player.reference || null,
      email: player.email || null,
      gender: null,
      handicap: player.ffg ? player.ffg.handicap : null,
      lastname: player.lastname || null,
      firstname: player.firstname || null,
      licenseNo: player.ffg ? player.ffg.license : null,
      payments: [
        {
          amount: pricing && pricing[index] ? pricing[index].price || 0 : 0,
          type: paymentMethod,
          // Seul le 1er joueur porte le walletId, et seulement en compte client :
          // c'est `players[0].payments[0].walletId` que lit le resolver master.
          walletId: index === 0 && paymentMethod === 2 ? walletId || null : null,
        },
      ],
      subscriptionBeneficiaryId: null,
      playerType: {
        id: bookingInfo.typeId,
        name: activity.name,
      },
      price: pricing && pricing[index] ? pricing[index].price || 0 : 0,
      discount: pricing && pricing[index] ? pricing[index].discount || 0 : 0,
      initPrice: pricing && pricing[index] ? pricing[index].price || 0 : 0,
    })),
    isPrivatized: 0,
    forceAnonymous: 0,
  };

  return client
    .mutate({
      mutation: gql`
        ${queries.gql.ACTIVITY_BOOK}
      `,
      variables,
    })
    .then(({ data }) => data.activityBook);
};

/* */
export const getActivity = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${queries.gql.GET_ACTIVITY}
      `,
      fetchPolicy,
      variables,
    })
    .then(({ data }) => ({ bookings: data.getActivity }));

/* */
export const getActivityHistory = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${queries.gql.GET_ACTIVITY_HISTORY}
      `,
      fetchPolicy,
      variables,
    })
    .then(({ data }) => ({ bookings: data.getActivityHistory }));
